export default "__VITE_ASSET__DHwBsbn2__"